/**
 * Controller: UsersAddGroupsModal
 */
angular.module('acme.view.application.users.addGroupsModal.controllers', [
  'acme.common.service.api'
])
.controller('UsersAddGroupsModalController', [ '$scope', '$uibModalInstance', 'ApiService', 'userData', 'userGroups', function ($scope, $uibModalInstance, ApiService, userData, userGroups) {

    $scope.errors = [];

    $scope.model = [];

    $scope.query = '';

    $scope.init = function() {

      ApiService.groups.list({
        page: 1,
        pageSize: -1,
        sortDirection: "asc",
        sortField: "name"
      }).then(function(response) {
        var i, ii,
            j, jj,
            groups = response.data.payload.list;

        for (i=0,ii=groups.length;i<ii;i++) {
          for (j=0,jj=userGroups.length;j<jj;j++) {
            if (groups[i].id === userGroups[j].id) {
              groups[i].selected = true;
              break;
            }
          }
        }

        $scope.model = groups;

      }, function(response) {
        // TODO: Backfill
      });

    };

    $scope.checkQuery = function(user, query) {
      var q = '';
      if (user.displayName) {
        q += user.displayName;
      }
      if (user.name) {
        q += user.name;
      }
      q = q.toLowerCase();

      console.log('UsersAddGroupsModalController::search', query);
      return (q.indexOf(query) === -1);
    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.getSelected = function() {
      var i, ii,
          groups = [],
          mappings = [];

      // Returns only the relationship between user and group
      for (i=0,ii=$scope.model.length;i<ii;i++) {
        if ($scope.model[i].selected) {
          groups.push($scope.model[i]);
          mappings.push({
            userId: userData.id,
            userGroupId: $scope.model[i].id
          });
        }
      }

      return { mappings: mappings, groups: groups };
    };

    $scope.done = function() {
      $scope.success();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close($scope.getSelected());
    };

    $scope.init();

}]);